import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "meta"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProgressStepperStepLabelText from './ProgressStepperStepLabelText';
import Text from '../Text/Text';
import { ProgressStepperStepLabelMixin } from '../../mixins/components/ProgressStepperStepLabelMixin';
import { TAG_SIZES } from '../../constants/TAG';
export var StyledProgressStepperStepLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledProgressStepperStepLabel",
  componentId: "c11n-8-64-0__sc-hxgzn-0"
})(["", ""], ProgressStepperStepLabelMixin);
/**
 * Used by [`ProgressStepperStep`](#/More%20components?id=progressstepperstep) to wrap
 * a step's label text and any additional `meta` content.
 *
 * @since 8.57.0
 */

var ProgressStepperStepLabel = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _meta$type;

  var label = _ref.label,
      meta = _ref.meta,
      rest = _objectWithoutProperties(_ref, _excluded);

  var metaContent = meta;

  if (typeof meta === 'string') {
    metaContent = /*#__PURE__*/React.createElement(Text, {
      fontType: "bodySmall"
    }, meta);
  } else if ((meta === null || meta === void 0 ? void 0 : (_meta$type = meta.type) === null || _meta$type === void 0 ? void 0 : _meta$type.displayName) === 'Tag') {
    // Force Tag to display at small size
    metaContent = /*#__PURE__*/React.cloneElement(meta, {
      size: TAG_SIZES.sm
    });
  }

  return /*#__PURE__*/React.createElement(StyledProgressStepperStepLabel, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(ProgressStepperStepLabelText, null, label), metaContent);
});
ProgressStepperStepLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Label text of the step.
   */
  label: PropTypes.string.isRequired,

  /**
   * Additional content that will appear underneath the step label text. Currently,
   * [`Tag`](#/More%20components/Tag) and text are officially supported. For more
   * customization options, you can use the `renderLabel` prop.
   *
   * It's best to avoid long `meta` values to help maintain understandability
   * for screen reader users.
   *
   * @since 8.57.0
   */
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
} : {};
/** @component */

export default ProgressStepperStepLabel;